import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  height: 100vh;
  width: 100vw;

  cursor: url('/assets/images/cursors/purple_cursor_16.png'), auto;
`;
